import { Controller, useFormContext } from 'react-hook-form'

import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'
import SubcategorySelector from 'modules/expenses/components/expenses/Form/SubcategorySelector'

const FIELD_NAME = 'subcategory'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  category: string
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
}

const SubcategoryField = ({
  isFieldMandatory,
  customizationFields,
  category,
  isFieldReadOnly,
  resourceType,
  asReviewer,
}: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Controller
      control={control}
      name={FIELD_NAME}
      render={({ field }) => (
        <SubcategorySelector
          customizationFields={customizationFields}
          resourceType={resourceType}
          category={category}
          asReviewer={asReviewer}
          value={field.value}
          onSelectedSubcategory={(value) => field.onChange(value)}
          mandatory={isFieldMandatory}
          error={castError(errors?.subcategory)}
          readonly={isFieldReadOnly}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(SubcategoryField, FIELD_NAME))
